var _rect, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayslipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.002 512.002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 74.395,
    style: {
      fill: "#FFFFFF"
    },
    width: 384.271,
    height: 325.605
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M384.27,78.4v317.598H8V78.4H384.27 M392.27,70.4H0v333.598h392.27V70.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.592,
    y: 233.2,
    style: {
      fill: "#CCCCCC"
    },
    width: 289.089,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.592,
    y: 184.428,
    style: {
      fill: "#CCCCCC"
    },
    width: 289.089,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.592,
    y: 135.645,
    style: {
      fill: "#CCCCCC"
    },
    width: 289.089,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.592,
    y: 330.755,
    style: {
      fill: "#CCCCCC"
    },
    width: 289.089,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.592,
    y: 281.982,
    style: {
      fill: "#CCCCCC"
    },
    width: 289.089,
    height: 8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 392.567,
    y: 320.168,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -117.9016 383.4036)",
    style: {
      fill: "#E21B1B"
    },
    width: 22.583,
    height: 27.708
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 397.614,
    y: 339.013,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -126.4652 404.5227)",
    width: 54.91,
    height: 31.811
  })), /*#__PURE__*/React.createElement("rect", {
    x: 437.011,
    y: 354.298,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -142.6084 443.8471)",
    style: {
      fill: "#E21B1B"
    },
    width: 54.91,
    height: 79.539
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 321.09,
    cy: 233.843,
    r: 120.601
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFEFEF"
    },
    cx: 321.09,
    cy: 233.843,
    r: 101.616
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21B1B"
    },
    d: "M349.11,283.462c-7.893,4.472-16.816,6.805-25.888,6.768c-14.755,0.411-28.872-6.024-38.239-17.432 c-5.899-7.205-9.598-15.956-10.656-25.208h-10.824v-10.32h9.472v-2.712c0-2.031,0.168-4.224,0.344-6.088h-9.816v-10.487h11.336 c1.733-9.541,6.131-18.398,12.688-25.544c9.263-10.399,22.62-16.213,36.544-15.904c8.351-0.064,16.611,1.728,24.184,5.248 l-4.256,15.728c-5.866-3.004-12.362-4.57-18.952-4.568c-8.182-0.208-16.041,3.195-21.488,9.304 c-3.867,4.471-6.443,9.912-7.448,15.736h44.367v10.496h-46.36c-0.284,1.96-0.397,3.941-0.336,5.92v2.872h46.695v10.32h-44.8 c0.747,6.12,3.279,11.885,7.28,16.576c5.907,6.124,14.137,9.447,22.639,9.144c6.976-0.078,13.832-1.819,20-5.08L349.11,283.462z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayslipIcon);
export default __webpack_public_path__ + "static/media/payslipIcon.01daa7ce45fe368adc3308fb5aee7935.svg";
export { ForwardRef as ReactComponent };